/** @file Copies the iso grid tile size into the direction set (iso sector centres), or clears it. */
import { z } from 'zod';
import { isoTileHeight } from '@pose2d/core/direction/isoTileHeight';
import { defineCommand } from '../defineCommand';
import { directionsDraft } from './directionsDraft';

/** direction.syncIso: iso = the iso grid's tile size (W2-31), removed for other grids; an unchanged iso is a no-op. */
export const command = defineCommand({
  name: 'direction.syncIso',
  description: 'Copy view.grid into the direction set as iso [tileW, tileH] (isoAngle 30 uses max(1, round(tileW * tan 30deg))) so diagonal sectors match the iso grid; clears it when the grid is not iso.',
  input: z.object({}).strict(),
  apply(draft, input, ctx) {
    const set = directionsDraft(draft, 'directions');
    const grid = draft.view.grid;
    const iso: [number, number] | undefined = grid.mode === 'iso' ? [grid.tileW, grid.isoAngle === 30 ? isoTileHeight(grid.tileW) : grid.tileH] : undefined;
    if (JSON.stringify(iso) === JSON.stringify(set.iso)) return;
    if (iso === undefined) delete set.iso;
    else set.iso = iso;
    draft.meta.updatedAt = ctx.now;
  },
});
